import { render, staticRenderFns } from "./NewUserLogin.vue?vue&type=template&id=b0dd012a&"
import script from "./NewUserLogin.vue?vue&type=script&lang=js&"
export * from "./NewUserLogin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports